import UnpicImage from "@/components/common/unpicImage/UnpicImage";
import { type IGenAsset } from "@/services/graphql/__generated/sdk";
import { type Nullable } from "@/utils/types";

import React from "react";

import * as styles from "./Asset.style";

interface IAsset extends IGenAsset
{
  readonly children?: React.ReactNode;
  readonly description?: Nullable<string>;
  readonly src?: Nullable<string>;
}

export const Asset: React.FC<IAsset> = ({ children, description, src }) => 
{
  return (
    <>
      {src && (
        <div css={styles.wrapper}>
          <UnpicImage
            src={src}
            alt={description ?? ""}
            layout="fullWidth"
            background="auto"
          />
          {description && (
            <label css={styles.description}>
              {description}
            </label>
          )}
        </div>
      )}
      {children}
    </>
  );
};
